import React from 'react';
import type { RegistrationType } from './AdhesionFormContainer';

interface Props {
  type: RegistrationType;
  onReset: () => void;
}

export default function SuccessState({ type, onReset }: Props) {
  return (
    <div
      className="rounded-2xl card-shadow-lg overflow-hidden animate-slide-up"
      style={{ backgroundColor: 'var(--card)' }}
    >
      <div className="p-8 sm:p-12 flex flex-col items-center text-center gap-6">
        {/* Success icon */}
        <div
          className="w-20 h-20 rounded-full flex items-center justify-center"
          style={{ backgroundColor: 'var(--success-bg)' }}
        >
          <svg
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
            stroke="var(--success)"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
          </svg>
        </div>

        {/* Heading */}
        <div className="flex flex-col gap-2">
          <h2
            className="text-2xl font-700"
            style={{ color: 'var(--foreground)', fontWeight: 700 }}
          >
            Cadastro realizado com sucesso!
          </h2>
          <p
            className="text-base leading-relaxed"
            style={{ color: 'var(--muted-foreground)' }}
          >
            Em breve nossa equipe entrará em contato para apresentar as melhores
            soluções de rastreabilidade para{' '}
            {type === 'pj' ? 'a sua empresa' : 'o seu rebanho'}.
          </p>
        </div>

        {/* Info card */}
        <div
          className="w-full rounded-xl p-5 flex flex-col gap-3 text-left"
          style={{
            backgroundColor: 'var(--primary-light)',
            border: '1px solid rgba(42,125,79,0.2)',
          }}
        >
          <p
            className="text-sm font-600"
            style={{ color: 'var(--primary)', fontWeight: 600 }}
          >
            O que acontece agora?
          </p>
          {[
            'Nossa equipe analisará seu cadastro em até 1 dia útil.',
            'Você receberá um e-mail de confirmação com mais informações.',
            'Um especialista entrará em contato pelo WhatsApp para agendar uma demonstração.',
          ].map((step, i) => (
            <div
              key={`success-step-${i + 1}`}
              className="flex items-start gap-3"
            >
              <span
                className="w-5 h-5 rounded-full flex-shrink-0 flex items-center justify-center text-xs font-700 mt-0.5"
                style={{
                  backgroundColor: 'var(--primary)',
                  color: 'var(--primary-foreground)',
                  fontWeight: 700,
                  fontSize: '0.7rem',
                }}
              >
                {i + 1}
              </span>
              <p className="text-sm" style={{ color: 'var(--foreground)' }}>
                {step}
              </p>
            </div>
          ))}
        </div>

        {/* Contact info */}
        <div
          className="flex flex-col sm:flex-row items-center gap-3 text-sm"
          style={{ color: 'var(--muted-foreground)' }}
        >
          <span>Dúvidas? Fale conosco:</span>
          <a
            href="tel:+5551999609496"
            className="flex items-center gap-1.5 font-600 transition-colors"
            style={{ color: 'var(--primary)', fontWeight: 600 }}
          >
            <svg
              width="15"
              height="15"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.77a16 16 0 0 0 6.29 6.29l.95-.96a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
            </svg>
            (51) 99960-9496
          </a>
        </div>

        {/* New registration CTA */}
        <button
          onClick={onReset}
          className="text-sm underline transition-colors"
          style={{ color: 'var(--muted-foreground)', background: 'none', border: 'none', cursor: 'pointer' }}
        >
          Fazer outro cadastro
        </button>
      </div>
    </div>
  );
}